<div class="bg-white rounded border p-3 w-100 shadow min-h-14rem">
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center fs-4 fw-bold text-secondary">
      <span class="accent-bar me-2"></span>
      <span>{{ title }}</span>

      @if (infoTooltip) {
      <span
        class="ms-1"
        matTooltip="{{ infoTooltip }}"
        matTooltipPosition="above"
        matTooltipClass="tooltip-custom"
        style="cursor: pointer"
      >
        <i class="mdi mdi-information-outline fs-6 text-muted"></i>
      </span>
      }
    </div>

    <div class="fs-5 fw-bold text-secondary">{{ total }}</div>
  </div>

  <div class="mt-3 d-flex flex-column gap-2">
    @for (item of items; track item.label) {
    <div
      class="d-flex align-items-center justify-content-between fs-5 text-secondary fw-bold"
    >
      <div class="d-flex align-items-center gap-2">
        <div class="dash-line mt-1" [ngClass]="item.colorClass"></div>
        <span>{{ item.label }}</span>
      </div>
      <div class="text-dark">{{ item.value }}</div>
    </div>
    }
  </div>
</div>
